<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero">
        <template #play>
          <AtomButton
            v-if="club.spaYoutubeIframe"
            class="md:!hidden !absolute top-0 right-0 self-end btn-icon btn-lg btn-white"
            @click="modal = 'video'"
          >
            <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.5 2.00161C0.5 0.823454 1.79592 0.105187 2.795 0.729608L9.689 5.03836C10.629 5.62586 10.629 6.99485 9.689 7.58235L2.795 11.8911C1.79592 12.5155 0.5 11.7973 0.5 10.6191V2.00161ZM2.265 1.57761C1.93198 1.36947 1.5 1.60889 1.5 2.00161V10.6191C1.5 11.0118 1.93198 11.2512 2.265 11.0431L9.159 6.73435C9.47234 6.53852 9.47234 6.08219 9.159 5.88636L2.265 1.57761Z"
                fill="white"
              />
            </svg>
          </AtomButton>
        </template>
      </OrganismHero>
      <template #footerShort>
        <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] justify-end">
          <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] md:items-end -md:order-2">
            <AtomButton class="btn-white self-end -md:order-1 -md:w-full" :data-yclients-url="yclients">
              ВЫБРАТЬ УСЛУГУ</AtomButton
            >
            <AtomButton
              v-if="club.spaWhatsapp"
              :href="club.spaWhatsapp"
              tag="a"
              class="btn-white self-end -md:order-1 -md:w-full"
            >
              TELEGRAM
            </AtomButton>
          </div>
          <AtomButton
            v-if="club.spaYoutubeIframe"
            class="-md:!hidden self-end btn-icon btn-lg btn-white"
            @click="modal = 'video'"
          >
            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.68234 12.5438L2.15234 11.6958L2.68234 12.5438ZM10.23 7.82654L9.69996 6.97854L10.23 7.82654ZM10.76 5.28254L3.21234 0.565283L2.15234 2.26128L9.69996 6.97854L10.76 5.28254ZM0.152344 2.26128V11.6958H2.15234V2.26128H0.152344ZM3.21234 13.3918L10.76 8.67454L9.69996 6.97854L2.15234 11.6958L3.21234 13.3918ZM0.152344 11.6958C0.152344 13.2667 1.88024 14.2244 3.21234 13.3918L2.15234 11.6958V11.6958H0.152344ZM3.21234 0.565283C1.88025 -0.267276 0.152344 0.690405 0.152344 2.26128H2.15234L2.15234 2.26128L3.21234 0.565283ZM9.69996 6.97854L9.69996 6.97854L10.76 8.67454C12.0133 7.8912 12.0133 6.06588 10.76 5.28254L9.69996 6.97854Z"
                fill="white"
              />
            </svg>
          </AtomButton>
        </div>
      </template>
    </SectionHero>
    <ModalSimpleVideo v-if="modal === 'video'" :iframe-html="club.spaYoutubeIframe" @close="modal = null" />
    <SectionDefault>
      <Builder :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
import AtomButton from '../../components/atoms/AtomButton'
import Builder from '../../components/builder/Builder'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import ModalSimpleVideo from '../../components/organisms/modals/SimpleVideo'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: ({ route }) => `spa_${route.params.id}`,
})

export default {
  name: 'SpaId',
  components: {
    AtomButton,
    Builder,
    SectionDefault,
    SectionHero,
    OrganismHero,
    ModalSimpleVideo,
  },
  mixins: [mixinPageBuilder],
  data() {
    return {
      modal: null,
    }
  },
  computed: {
    club() {
      return (
        this.$store.getters['modules/content/clubs'].find(c => c.slug === this.$route.params.id) || { spaTitle: '' }
      )
    },
    yclients() {
      return `${this.club.spaClient || 'https://n794050.yclients.com'}/widgetJS`
    },
    hero() {
      // const title = this.club.spaTitle.split(/\s+/g)
      const title = (this.club.spaTitle || this.club.title).split(/\s+/g)
      const breadcrumbs = this.$breadcrumbs.spaClub({
        spaTitle: title.map(t => capitalize(t)).join(' '),
        spaSlug: this.club.slug,
      })
      const title2 = title.pop()
      const title1 = title.join(' ')
      return {
        variant: 'transparent-parallax',
        imageWrap: 'img-border-0',
        strapiImageObject: this.$device.isDesktop
          ? this.club.spaHeroImage
          : this.club.spaHeroImageMobile || this.club.spaHeroImage,
        backgroundVideo: this.club.spaHeroVideo,
        title1,
        title2,
        breadcrumbs,
      }
      function capitalize(string) {
        if (!string) return ''
        return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1)
      }
    },
  },
}
</script>
